import React, {memo, ReactNode, useEffect} from 'react';
import './index.scss';
import {Container} from '../Container';
import {useLocalization} from "../../hooks/localization";

type Props = {
    isConnected: boolean;
    retryCount: number;
    children?: ReactNode;
};

const ConnectionIndicator = memo(function ConnectionIndicator({retryCount}: { retryCount: number }) {
    const {t} = useLocalization();
    return (
        <Container className={'no-sidebar fullscreen d-flex'}>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'white',
                textAlign: 'center',
                lineHeight: '30px',
                flex: 1,
            }}>
                {t('TRYING_TO_CONNECT')}
                {renderIf(retryCount > 2)(() =>
                    <>
                        <br/>
                        {t('NUMBER_OF_ATTEMPTS', {retryCount:retryCount.toString()})}
                    </>,
                )}
            </div>
        </Container>
    );
});

export const Viewport = memo(function Viewport({children, isConnected, retryCount}: Props) {
    return (
        <>
            {
                renderIf(isConnected)(() => children, () => <ConnectionIndicator retryCount={retryCount}/>)
            }
        </>
    );
});
